const requireImages = require.context(
  "./Fallback",
  true,
  /^(?!.*(?:interCape09|interCape08|grayhound09)).*\.(png|jpe?g|jfif|webp)$/
);

const fallbackImages = {};
const excludedImages = new Set(["interCape09.png", "interCape08.png", "grayhound09.jpg"]);
const leadImagePreference = {
  "ambassador lodge": ["ambassador05.jpg"],
  "Big Hole": ["bigHole04.jpg"],
  "Magersfontein Battlefield": ["magersfonteinBattlefield05.jpg"],
  "Kimberley Mine Museum": ["mineMuseum06.jpg"],
  "Mogregor museum": ["mcgregor06.jpg"],
  "Diamond Pavilion Mall": ["diamond05.jpg", "diamond06.jpg"],
  "Northern Cape Mall": ["northern06.jpg", "northern07.jpg"],
  "Lyve Cafe": ["lyve04.jpg", "lyve03.jpg"],
  "The Hussar Grill": ["hussarGrill05.jpg"],
  "Occidental Bar & Restaurant": ["occidentalRestaurant04.jpg"],
  "Inter city": ["interCity06.png", "interCity07.jpg"],
  "Inter Cape": ["interCape03.jpg", "interCape02.jpg"],
  Greyhound: ["grayhound08.webp", "grayhound06.jpg"],
  "City to City": ["cityToCity05.jpg", "cityToCity07.jpg"],
};

requireImages.keys().forEach((filePath) => {
  const parts = filePath.split("/");

  // folder name = second last item
  const folder = parts[1];
  const fileName = parts[2];

  if (excludedImages.has(fileName)) {
    return;
  }

  if (!fallbackImages[folder]) {
    fallbackImages[folder] = [];
  }

  fallbackImages[folder].push({
    fileName,
    src: requireImages(filePath),
  });
});

Object.keys(fallbackImages).forEach((folder) => {
  const preferredFiles = leadImagePreference[folder] || [];

  fallbackImages[folder] = fallbackImages[folder]
    .sort((a, b) => {
      const aIndex = preferredFiles.indexOf(a.fileName);
      const bIndex = preferredFiles.indexOf(b.fileName);

      if (aIndex !== -1 || bIndex !== -1) {
        return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
      }

      return a.fileName.localeCompare(b.fileName);
    })
    .map((image) => image.src);
});

export default fallbackImages;
